module.exports = __webpack_public_path__ + "img/sybcs.f625e63d.png";